import { useContext } from 'react';
import { BsBag } from 'react-icons/bs';

import { CartContext } from '../../contexts/cart.context';
import './cart-icon.styles.scss';

const CartIcon = () => {
  const { isCartOpen, setIsCartOpen, cartCount } = useContext(CartContext);

  const toggleIsCartOpen = () => setIsCartOpen(!isCartOpen);

  return (
    <button
      type="button"
      className="cart-icon-container"
      aria-label={`Panier, ${cartCount} article${cartCount > 1 ? 's' : ''}`}
      onClick={toggleIsCartOpen}
    >
      <BsBag className="shopping-icon" />
      {cartCount > 0 && <span className="item-count">{cartCount}</span>}
    </button>
  );
};

export default CartIcon;
